<template>
  <header class="nav-bar">
    <div class="nav-bar-left">
      <button @click="goBack" class="nav-bar-button">
        <!-- 返回按钮图标 -->
        <img class="backimg" src="../assets/back.png">
      </button>
    </div>
    <div class="nav-bar-title">
      <!-- 动态显示标题 -->
      <h1>{{ title }}</h1>
    </div>
    <div class="nav-bar-right">
      <!-- 右侧按钮，例如菜单按钮 -->
      <slot name="right-button"></slot>
    </div>
  </header>
</template>

<script>
export default {
  props: {
    //网页标题
    title: {
      type: String,
      default: ''
    },
    //指定跳转页面
    coupon: {
      type: Number,
      default: null
    },
    routerData:{
      type:Object,
      default:null
    }
  },
  methods: {
    goBack() {
      // alert("我不想退出")

      if(this.coupon){
        let query = {
          coupon:this.coupon
        };
        if(this.routerData){
          for (let key in this.routerData) {
            if (this.routerData.hasOwnProperty(key)) {
              query[key] = this.routerData[key];
            }
          }
        }

        this.$router.push({
          name: 'coupon',
          query: query
        })
      }else{
        this.$router.push({
          name: 'shopIndex',
        })
      }
      // this.$router.back();
    }
  }
};
</script>

<style scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  height: 50px;
  background-color: #fff;
  border-bottom: 1px solid #ddd;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.nav-bar-left,
.nav-bar-right {
  flex: 0 0 auto;
}

.nav-bar-right img{
  width: 25px;
}
.nav-bar-title {
  flex: 1;
  text-align: center;
  max-width: 150px; /* 或者其他合适的宽度 */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-bar-button {
  background: none;
  border: none;
  font-size: 16px;
  color: #007bff;
}

.nav-bar-button:focus {
  outline: none;
}

.nav-bar-title h1 {
  margin: 0;
  font-size: 18px;
  font-weight: normal;
}
@keyframes scrollText {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.backimg{
  width: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/navBar.vue